import "./Styles/Cookies.css";
import Main from "./Components/Home/Main";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import BusinessAutomation from "./RedirectingPages/NavbarPages/BusinessAutomation";
import BusinessAudit from "./RedirectingPages/NavbarPages/BusinessAudit";
import BespokeSystem from "./RedirectingPages/NavbarPages/BespokeSystem";
import SoftwareDevelopment from "./RedirectingPages/NavbarPages/SoftwareDevelopment";
import WebsiteDevelopment from "./RedirectingPages/NavbarPages/WebsiteDevelopment";
import MobileApp from "./RedirectingPages/NavbarPages/MobileApp";
import DedicatedResource from "./RedirectingPages/NavbarPages/DedicatedResource";
import Blog from "./RedirectingPages/FooterPages/Blog";
import BlogDetails from "./RedirectingPages/FooterPages/AllBlogs/BlogDetails";
import { Fragment } from "react";
import ScrollToTop from "./Components/seperate Components/ScrollToTop";
import ContactUs from "./RedirectingPages/FooterPages/ContactUs";
import Career from "./RedirectingPages/FooterPages/Career";
import Details2 from "./RedirectingPages/FooterPages/CareerDetails/Details2";
import AboutCompany from "./RedirectingPages/FooterPages/AboutCompany";
import Policy from "./RedirectingPages/FooterPages/Policy";
import PricingTable from "./RedirectingPages/FooterPages/PricingTable";
import SeoManagement from "./RedirectingPages/Packages/SeoManagement";
import MainTestimonial from "./RedirectingPages/FooterPages/MainTestimonial";
import DigitalMarketing from "./RedirectingPages/FooterPages/DigitalMarketing";
import HostingServices from "./RedirectingPages/FooterPages/HostingServices";
import MicroService from "./RedirectingPages/FooterPages/MicroService";
import CurrentOPening from "./RedirectingPages/FooterPages/CurrentOPening";
import CaseStudy1 from "./Components/Case Studies/CaseStudy1";
import PageNotFound from "./Components/seperate Components/PageNotFound";
import SiteMap from "./Components/seperate Components/SiteMap";
import MainCaseStudy from "./Components/Case Studies/MainCaseStudy";
import AllGallery from "./RedirectingPages/AllGallery";
import EmployeeVideo from "./RedirectingPages/EmployeeVideo";
import TeamMembers from "./RedirectingPages/TeamMembers";
import ReactGA from "react-ga";
import { createBrowserHistory } from "history";
import CookieConsent from "react-cookie-consent";
import axios from "axios";
import ScrollTop from "./Components/seperate Components/ScrollTop";
import CallBack from "./Components/seperate Components/CallBack";
import Arkzi from "./RedirectingPages/FooterPages/Arkzi";

ReactGA.initialize("UA-76559070-1");
const browserHistory = createBrowserHistory();
browserHistory.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search);
  console.log(location.pathname);
});

function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const [ip, setIP] = useState("");
  const [long, setLong] = useState("");
  const [latt, setLatt] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");

  const getData = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setLatt(res.data.latitude);
    setLong(res.data.longitude);
    setIP(res.data.IPv4);
    setCity(res.data.city);

    setCountry(res.data.country_name);
  };
  useEffect(() => {
    getData();
  }, []);

  const [shown, setShown] = useState(true);

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 2 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + true + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      setCookie("zithasTech", user, 30);
    }
    localStorage.setItem("latitude", latt);
    localStorage.setItem("longitude", long);
    localStorage.setItem("IpAddress", ip);
    localStorage.setItem("City", city);
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";
    // }
  }

  // useEffect(() => {
  //   let user = getCookie("zithasTech");
  //   if (user != "") {
  //     var x = document.getElementById("cookiesBox");
  //     x.style.display = "none";
  //   }
  // }, []);

  function checkCookieBanner() {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      var x = document.getElementById("cookiesBox");
      x.style.display = "block";
    }
  }

  const onDecline = () => {
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";
  };

  const onSaveSettings = () => {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      setCookie("zithasTech", user, 30);
    }
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";

    var checkBox = document.getElementById("analytics_cookies");
    if (checkBox.checked == true) {
      localStorage.setItem("latitude", latt);
      localStorage.setItem("longitude", long);
      localStorage.setItem("IpAddress", ip);
      localStorage.setItem("City", city);
    } else if (checkBox.checked == false) {
      return false;
    }

    var checkBox = document.getElementById("functional_cookies");
    if (checkBox.checked == true) {
      console.log("Functional Coocikes is Acctivated");
    } else {
      console.log("Functional Coocikes is Deacctivated");
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Fragment>
          {/* <ScrollToTop /> */}
          <ScrollTop />
          <CallBack />
          <Routes>
            <Route exact path="/" element={<Main />} />
            <Route path="*" element={<PageNotFound />} />
            <Route  
              path="/business-automation"
              element={<BusinessAutomation />}
            />
            <Route
              path="/business-software-audit"
              element={<BusinessAudit />}
            />
            <Route path="/bespoke-systems" element={<BespokeSystem />} />
            <Route
              path="/custom-software-development"
              element={<SoftwareDevelopment />}
            />
            <Route
              path="/website-development"
              element={<WebsiteDevelopment />}
            />
            <Route path="/mobile-apps-development" element={<MobileApp />} />
            <Route path="/hire-a-resource" element={<DedicatedResource />} />

            <Route path="/blog/" element={<Blog />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/career" element={<Career />} />
            <Route path="/gallery" element={<AllGallery />} />
            <Route path="/employee-testimonial" element={<EmployeeVideo />} />
            <Route path="/pillars-of-zithas" element={<TeamMembers />} />

            <Route path="/case-study/:permalink" element={<CaseStudy1 />} />

            <Route path="/about-us" element={<AboutCompany />} />
            <Route path="/privacy-policy" element={<Policy />} />
            <Route path="/Maintenance-Packages" element={<PricingTable />} />
            <Route path="/testimonials" element={<MainTestimonial />} />
            <Route path="/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/hosting-service" element={<HostingServices />} />
            <Route path="/micro-service" element={<MicroService />} />
            <Route path="/blog/:permalink" element={<BlogDetails />} />

            <Route path="/current-opening/:permalink" element={<Details2 />} />
            <Route
              path="/seo-management-packages"
              element={<SeoManagement />}
            />
            <Route path="/current-openings" element={<CurrentOPening />} />
            <Route path="/sitemap" element={<SiteMap />} />
            <Route path="/case-studies" element={<MainCaseStudy />} />
            <Route path="/wba-embedded-signup" element={<Arkzi />} />

           
          </Routes>

        </Fragment>
      </BrowserRouter>
    </div>
  );
}

export default App;
